import { render, staticRenderFns } from "./LengthAgeChart.vue?vue&type=template&id=b57b9af6&"
import script from "./LengthAgeChart.vue?vue&type=script&lang=ts&"
export * from "./LengthAgeChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports